import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "k-radial-picker" }
const _hoisted_2 = { class: "k-radial-picker__tier tier-1" }
const _hoisted_3 = ["id", "onPointerdown"]
const _hoisted_4 = { class: "k-radial-picker__tier tier-2" }
const _hoisted_5 = ["id", "onPointerdown"]

import { ref } from 'vue';
import { useMotion, useMotions } from '@vueuse/motion';
import { getGameSetTransitions, gameSetLeave } from './transitions';
import ColorButton from './color-button.vue';
import chroma from 'chroma-js';
import { sample } from 'lodash';
import { hapticsImpactLight } from 'src/util/device-util';
import { useModule } from 'src/modules/modules';
import { chunkArray } from 'util/util';


export default /*#__PURE__*/_defineComponent({
  __name: 'radial-color-picker',
  props: {
    colors: null,
    eliminiation: { type: Boolean }
  },
  emits: ['enter', 'select'],
  setup(__props: any, { expose, emit }) {

const { colors = [], eliminiation = false } = __props as {
    colors: chroma.Color[],
    eliminiation?: boolean
}

const { game } = useModule();
game.useReducedPadding = true;




const getTierChunks = (colors: chroma.Color[]) => {
    if (colors.length <= 12) return [colors, []];
    else if (colors.length < 18) return chunkArray(colors, [colors.length / 2, colors.length / 2]);
    else return chunkArray(colors, [12, 8]);
}

/**
 * Split our colors in two tiers. For smaller color sets, we want to split them evenly.
 */
// const [colorsTier1, colorsTier2] = colors.length < 18 ? 
//     chunkArray(colors, [colors.length / 2, colors.length / 2]) : 
//     chunkArray(colors, [12, 8]);

const [colorsTier1, colorsTier2] = getTierChunks(colors);

const divisions = 360 / colors.length;
const getBtnContinerStyle = (tier: chroma.Color[], index: number) => {
    const divisions = 360 / tier.length;
    //const color = tier[index];
    return {
        transform: `rotate(${index * divisions}deg) translate(0, -50%)`
    }
}   

const getBtnStyle = (tier: chroma.Color[], index: number) => {
    const color = tier[index];
    return {
        background: color.hex()
    }
}   

const tier1Ref = ref<HTMLElement>();
const teir1Motions = useMotion(tier1Ref, {
    initial: { 
        rotate: -360,
        scale: 0,
        opacity: 0
    },
    enter: {
        rotate: 0,
        scale: 1,
        opacity: 1,
        transition: {
            ease: 'easeOutSine',
            duration: 750,
            onComplete: () => {
                teir1Motions.apply('rotate');
                emit('enter');
            }
        }
    },
    rotate: {
        rotate: 360,
        transition: {
            repeat: Infinity,
            ease: 'linear',
            duration: 5000
        }
    },
    leave: {
        rotate: 360,
        scale: 0,
        opacity: 0,
        transition: {
            ease: 'linear',
            duration: 500,
            onComplete: () => game.useReducedPadding = false
        }
    }
})

const tier2Ref = ref<HTMLElement>();
const tier2Motions = useMotion(tier2Ref, {
    initial: { 
        rotate: 360,
        scale: 0,
        opacity: 0
    },
    enter: {
        rotate: 0,
        scale: 1,
        opacity: 1,
        transition: {
            ease: 'easeOutSine',
            duration: 750,
            onComplete: () => {
                tier2Motions.apply('rotate');
            }
        }
    },
    rotate: {
        rotate: -360,
        transition: {
            repeat: Infinity,
            ease: 'linear',
            duration: 5000
        }
    },
    leave: {
        rotate: 360,
        scale: 0,
        opacity: 0,
        transition: {
            ease: 'linear',
            duration: 500
        }
    }
})

const handleColorSelected = async (color: chroma.Color, id: string) => {
    hapticsImpactLight();
    emit('select', color);

    if (eliminiation){
        let el = document.getElementById(id);
        if (el) {
            const { apply, stop } = useMotion(el);
            apply({
                opacity: 0,
                scale: 3,
                transition: {
                    duration: 225,
                    ease: 'easeIn',
                    /**
                     * Necessary or else the element will sometimes hover invisible over another
                     * element, preventing it from being clicked.
                     */
                    onComplete: () => el?.remove()
                }
            })
        }
    }
}

expose({
    leave: () => {
        return Promise.all([
            teir1Motions.apply('leave'),
            tier2Motions.apply('leave')
        ])
    }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        ref_key: "tier1Ref",
        ref: tier1Ref,
        class: "k-radial-picker__ring"
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(colorsTier1), (color, i) => {
          return (_openBlock(), _createElementBlock("div", {
            id: `tier1Btn${i}`,
            style: _normalizeStyle(getBtnContinerStyle(_unref(colorsTier1), i)),
            class: "k-radial-picker__item-container",
            onPointerdown: () => handleColorSelected(color, `tier1Btn${i}`)
          }, [
            _createElementVNode("span", {
              class: "k-radial-picker__item",
              style: _normalizeStyle(getBtnStyle(_unref(colorsTier1), i))
            }, null, 4)
          ], 44, _hoisted_3))
        }), 256))
      ], 512)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", {
        ref_key: "tier2Ref",
        ref: tier2Ref,
        class: "k-radial-picker__ring"
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(colorsTier2), (color, i) => {
          return (_openBlock(), _createElementBlock("div", {
            style: _normalizeStyle(getBtnContinerStyle(_unref(colorsTier2), i)),
            id: `tier2Btn${i}`,
            class: "k-radial-picker__item-container",
            onPointerdown: () => handleColorSelected(color, `tier2Btn${i}`)
          }, [
            _createElementVNode("span", {
              class: "k-radial-picker__item",
              style: _normalizeStyle(getBtnStyle(_unref(colorsTier2), i))
            }, null, 4)
          ], 44, _hoisted_5))
        }), 256))
      ], 512)
    ])
  ]))
}
}

})